<div class="container-fluid text-center">
  <div class="col-sm-8 text-start">
    <h2>{{'group-instance.assignment' | translate}}</h2>
  </div>

  <!-- Management functions -->
  <div *ngIf="isManager$ | async">
    <button [attr.id]="'btnToggleCollapse'" (click)="helper.toggleSubject(isCollapseSubject)" mat-button>
      <span *ngIf="(isCollapse$ | async)"
        ><fa-icon [icon]="faChevronDown"></fa-icon> {{'group-instance.my_assigned_participants_management' | translate}}</span
      >
      <span *ngIf="(isCollapse$ | async) === false"
        ><fa-icon [icon]="faChevronUp"></fa-icon> {{'group-instance.my_assigned_participants_management' | translate}}</span
      >
    </button>
    <div *ngIf="(isCollapse$ | async)">
      <hr />

      <div class="row">
        <div class="col-12 col-sm-6 mb-2">
          <p>{{'group-instance.my_assigned_participants_add_description' | translate}}</p>
          <button
            [attr.id]="'btnOpenDialogGroupInterventionInstanceCreate'"
            class="largeButton"
            (click)="openDialogGroupInterventionInstanceCreate()"
            mat-button
            color="primary"
          >
            {{'group-instance.my_assigned_participants_add' | translate}}
          </button>
        </div>
        <div class="col-12 col-sm-6 mb-2">
          <p>{{'group-instance.add_ecoach_to_assigned_interventions_description' | translate}}</p>
          <button
            [attr.id]="'btnOpenDialogAddCollaboratorToECoachInstancesStudy'"
            class="largeButton"
            (click)="openDialogAddCollaboratorToECoachInstancesStudy()"
            mat-button
            color="primary"
          >
            {{'group-instance.add_ecoach_to_assigned_interventions' | translate}}
          </button>
        </div>
      </div>
    </div>
  </div>

  <hr />

  <div class="row justify-content-center">
    <div class="col-12 col-md-6 mb-2">
      <!-- Search bar -->
      <mat-form-field [style.width.%]="100" appearance="outline">
        <mat-label>{{ 'group-instance.search_user' | translate }}</mat-label>
        <input
          [attr.id]="'search'"
          (keyup.enter)="applyInstanceFilter(true)"
          [(ngModel)]="filter.searchFilter"
          [disabled]="(isLoading$ | async)"
          aria-describedby="instanceSearch"
          aria-label="Search"
          matInput
          type="text"
        />
        <button
          [attr.id]="'btnSearchInstance'"
          (click)="applyInstanceFilter(true)"
          [disabled]="(isLoading$ | async)"
          aria-label="Search"
          mat-button
          matSuffix
        >
          <mat-icon>search</mat-icon>
        </button>
      </mat-form-field>
    </div>
  </div>

  <section class="checkbox-center">
    <mat-checkbox
      [attr.id]="'checkboxExcludeCanceledInstance'"
      [(ngModel)]="excludeCanceledInstance"
      (change)="applyInstanceFilter(true)"
    >
      {{ 'intervention-instance.exclude_canceled_instances' | translate }}
    </mat-checkbox>
  </section>

  <app-pagination-list
    #paginator
    (emitPageChange)="updatePagedInterventionInstances($event)"
    [_isLoading]="isLoading$ | async"
    [_data]="instancesData$ | async"
  ></app-pagination-list>

  <ng-template #elseShowGroupInstances>
    <div class="row">
      <div *ngFor="let instance of pagedInstances$ | async; trackBy: helper.trackById" class="col-12 col-md-6 mb-3">
        <app-card-intervention-instance
          [_interventionInstance]="instance"
          [_users]="users"
          [_studyCollaborators]="studyCollaborators"
          (emitUpdatePerformed)="applyInstanceFilter()"
        ></app-card-intervention-instance>
      </div>
    </div>
  </ng-template>

  <div *ngIf="(isLoading$ | async); else elseShowGroupInstances">
    <app-loader></app-loader>
  </div>
</div>
